module.exports = __webpack_public_path__ + "static/media/404.3c703b8c.jpg";